import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { environment } from '../../../../environments/environment';
import { FilesService } from '../../../services/files.service';
const moment = require('moment');

@Component({
  selector: 'ngx-select-month-report',
  templateUrl: './select-month-report.component.html',
  styleUrls: ['./select-month-report.component.scss']
})
export class SelectMonthReportComponent implements OnInit {
  @Input() stationId: string;
  loading = false

  formData = {
    reportDate: new Date(),
    revisionNumber: '',
    revisionDate: new Date(),
    updateDate: new Date(),
    approvedDate: new Date(),
  };

  constructor(
    protected ref: NbDialogRef<SelectMonthReportComponent>,
    private fileService: FilesService,
  ) { }

  ngOnInit() {}

  async downloadFile(name: string) {
    this.loading = true;
    let query = `?rev_num=${this.formData.revisionNumber}`
    for (const key in this.formData) if (key.includes('Date')) query += `&${key}=${moment(this.formData[key]).format('YYYY-MM-DD')}`
    const url = `${environment.baseEndpoint}/annualProgram/station/${this.stationId}/report/v2${query}`;
    await this.fileService.downloadFile(url, name);
    this.loading = false;
    this.ref.close(false);
  }

  dismiss() { this.ref.close(false); }
}
